<template>
  <div class="store-item">
    <div class="store-content">
      <h1 class="store-header">{{ title }}</h1>
      <QS-column-box :source="source" :column="2" :list="list" separator=":" />
    </div>
    <div class="store-action">
      <el-button type="text" @click="delItem">删除</el-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})
const emits = defineEmits(['delete'])

const title = computed(() => {
  const { id, name } = props.data
  return `${id}  ${name}`
})
const source = computed(() => {
  const {
    cityName,
    contactTel,
    address,
  } = props.data
  return {
    cityName,
    contactTel,
    addressDesc: `${cityName}${address}`,
  }
})

const list = [
  {
    key: 'cityName',
    name: '城市',
  },
  {
    key: 'contactTel',
    name: '联系方式',
  },
  {
    key: 'addressDesc',
    name: '门店地址',
    alone: true,
  },
]
const delItem = () => {
  emits('delete', props.index)
}
</script>

<style lang="scss" scoped>
.store-item {
  border-radius: 8px;
  opacity: 1;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e7e8eb;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ::v-deep {
    .el-column-box__title {
      color: rgba(0, 0, 0, 0.6);
    }
  }
  .store-action {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    text-align: justify;
    letter-spacing: 0em;
    color: #366CFE;
    padding-left: 16px;
  }

  .store-content {
    flex: 1;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: calc(100% - 12px);
      background-color: #ebeef5;
    }
    >h1.store-header {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      padding: 0;
      margin: 0;
      margin-bottom: 8px;
      line-height: 22px;
      text-align: justify;
      letter-spacing: 0em;
      color: rgba(0, 0, 0, 0.9);
    }
    .info-item {
      display: flex;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      > span:first-child {
        color: #909399;
        margin-right: 8px;
      }
    }
    ::v-deep {
      .el-column-box > div {
        margin-bottom: 4px !important;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        text-align: justify;
        letter-spacing: 0em;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>
